import { ArrowRight } from "@phosphor-icons/react";

export function Hero() {
	return (
		<>
			<section className="relative min-h-svh overflow-hidden bg-surface">
				{/* Cityscape illustration — positioned behind content, visible immediately */}
				<div className="absolute inset-x-0 bottom-0 top-[40%] lg:top-auto w-full overflow-hidden">
					<img
						src="/illustrations/hero-cityscape.png"
						alt="Vibrant illustration of Lagos cityscape with the iconic bridge, skyscrapers, palm trees, and colorful vehicles"
						width={2752}
						height={1536}
						className="w-full h-full object-cover object-top lg:h-auto will-change-transform"
						loading="eager"
						fetchPriority="high"
						style={{ transform: "translateZ(0)" }}
					/>
				</div>

				{/* Gradient overlay — solid surface fading to transparent so illustration shows */}
				<div
					className="absolute inset-0 pointer-events-none"
					style={{
						background:
							"linear-gradient(to bottom, #F8FAFC 25%, rgba(248, 250, 252, 0.6) 50%, transparent 70%)",
					}}
				/>

				{/* Text Content — floats above the illustration */}
				<div className="relative z-10 pt-28 lg:pt-40 pb-12 lg:pb-16 px-4">
					<div className="max-w-5xl mx-auto text-center">
						{/* Badge */}
						<div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-border-subtle shadow-sm mb-8">
							<span className="relative flex h-2 w-2">
								<span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary opacity-75" />
								<span className="relative inline-flex h-2 w-2 rounded-full bg-secondary" />
							</span>
							<span className="text-sm font-semibold text-slate">
								Now in Public Beta
							</span>
						</div>

						{/* Headline */}
						<h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-dark mb-6 leading-[1.1]">
							Your time matters. <br className="hidden sm:block" />
							<span className="font-script text-primary font-normal text-5xl sm:text-6xl md:text-7xl -rotate-2 inline-block mt-2">
								We help save it.
							</span>
						</h1>

						{/* Subheadline */}
						<p className="mt-8 text-lg md:text-xl text-slate max-w-2xl mx-auto font-medium leading-relaxed">
							Post any errand in Lagos — groceries, pharmacy runs, document
							pickups, parcels — and a verified runner nearby handles it. Your
							money stays protected until you confirm the job is done.
						</p>
					</div>
				</div>

				{/* Wavy bottom edge — smooth transition out of the illustration */}
				<svg
					className="absolute -bottom-px left-0 w-full z-10"
					viewBox="0 0 1440 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					preserveAspectRatio="none"
					aria-hidden="true"
				>
					<path
						d="M0 120V60C120 20 240 0 360 10C480 20 600 60 720 70C840 80 960 50 1080 30C1200 10 1320 20 1380 25L1440 30V120H0Z"
						fill="#F8FAFC"
					/>
				</svg>
			</section>

			{/* CTA Buttons — below the illustration */}
			<section className="relative z-20 pt-10 px-4 pb-16">
				<div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-md mx-auto">
					<button
						type="button"
						data-tally-open="Bza1xR"
						data-tally-layout="modal"
						data-tally-width="700"
						data-tally-emoji-text="👋"
						data-tally-emoji-animation="wave"
						data-role="customer"
						className="w-full sm:w-auto flex items-center justify-center gap-2 bg-primary text-white px-8 py-4 rounded-2xl text-lg font-bold shadow-[0_6px_0_0_#2C3EB5] hover:translate-y-[2px] hover:shadow-[0_4px_0_0_#2C3EB5] active:translate-y-[4px] active:shadow-none transition-all"
					>
						Post an Errand <ArrowRight size={20} weight="bold" />
					</button>
					<button
						type="button"
						data-tally-open="Bza1xR"
						data-tally-layout="modal"
						data-tally-width="700"
						data-tally-emoji-text="👋"
						data-tally-emoji-animation="wave"
						data-role="runner"
						className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white text-dark border-2 border-border-subtle px-8 py-4 rounded-2xl text-lg font-bold shadow-[0_6px_0_0_#E2E8F0] hover:translate-y-[2px] hover:shadow-[0_4px_0_0_#E2E8F0] active:translate-y-[4px] active:shadow-none transition-all hover:border-dark"
					>
						Earn as a Runner
					</button>
				</div>
				{/* Trust strip */}
				<p className="mt-6 text-center text-sm font-medium text-slate">
					1,200+ already waiting · Free to join · Early access
				</p>
			</section>
		</>
	);
}
